module.exports = "https://coursera_assets.s3.amazonaws.com/images/e52474b9ae168dd2ce791c5cd0066987.png";